
import AccordionContainer from "../../common/accordion-container";
import PublishForm from "./publish-form";
import PublishHistory from "./publish-history";
import './publish.scss';

const Publish = () => {
  return (
    <>
      <AccordionContainer title="Publishing">
        <PublishForm />
      </AccordionContainer>

      <AccordionContainer className="publish-history" title="History">
        <PublishHistory />
      </AccordionContainer>
    </>
  )
}

export default Publish
